var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MyADGMeetings/MyADGMeetingsInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MyADGMeetings/MyADGMeetingsInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <ul class=\"MyADGMeetingsInner\">\n    ";
frame = frame.push();
var t_8 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("screening", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "<li>\n            <div class=\"MyADGMeetingsInner-item\">\n                <div class=\"MyADGMeetingsInner-itemDate\">\n                    ";
if(runtime.memberLookup((t_9),"date")) {
t_5 += "<div class=\"MyADGMeetingsInner-itemDay\">";
t_5 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_9),"date"),"%d"), env.opts.autoescape);
t_5 += "</div>\n                    <div class=\"MyADGMeetingsInner-itemMonth\">";
t_5 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_9),"date"),"%b"), env.opts.autoescape);
t_5 += "</div>\n                    ";
;
}
else {
t_5 += "<div class=\"MyADGMeetingsInner-itemTBD\">TBD</div>\n                    ";
;
}
t_5 += "</div>\n                <div class=\"MyADGMeetingsInner-itemTitle\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"title"), env.opts.autoescape);
t_5 += "</div>\n                <div class=\"MyADGMeetingsInner-itemDetails\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"details"), env.opts.autoescape);
t_5 += "</div>\n                <div class=\"MyADGMeetingsInner-itemCalendar\"><a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"calendar"), env.opts.autoescape);
t_5 += "\">Add To Calendar</a></div>\n            </div>\n        </li>\n    ";
;
}
}
frame = frame.pop();
t_5 += "\n    </ul>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MyADGMeetingsInner");
context.setVariable("MyADGMeetingsInner", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MyADGMeetings/MyADGMeetingsInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGMeetings/MyADGMeetingsInner.jinja
// module id = 57
// module chunks = 0